// Plan catalog mirror for the frontend (kept in sync with backend/config/plans.py).
// BUG-040 — la page publique des tarifs rend `FEATURE_LABELS[cle] || cle` et
// affichait donc `module_pointage`, `module_planning` et `module_rh` en toutes
// lettres : les cinq modules n'avaient de libellé dans aucune table. Un artisan
// lisait du jargon informatique sur la page qui vend le produit.
//
// Libellés identiques à `MODULE_LABELS` (backend/config/plans.py), et le test
// `libelles-tarifs.test.js` refuse tout écart entre les deux — c'est
// exactement la dérive qui a produit ce défaut.
export const FEATURE_LABELS = {
  module_pointage: "Pointage",
  module_planning: "Planning",
  module_rh: "RH",
  module_maintenance: "Maintenance",
  module_stock: "Stock",
  email_notifications: "Notifications par email",
  push_notifications: "Notifications push mobile",
  csv_export: "Export CSV",
  pdf_export: "Export PDF",
  api_access: "Accès API",
  slack_integration: "Intégration Slack/Teams",
  custom_branding: "Logo & couleurs personnalisés",
  priority_support: "Support prioritaire",
  payroll_connectors: "Connecteurs paie (Silae, PayFit)",
};

export const PLAN_ORDER = ["trial", "standard", "pro", "expert"];

export const PLAN_NAMES = {
  trial: "Essai gratuit",
  standard: "Standard",
  pro: "Pro",
  expert: "Expert",
};

// Locally-known features (used by PlanGate before the /plans call completes).
export const PLAN_FEATURES = {
  trial: {
    email_notifications: false,
    push_notifications: false,
    csv_export: true,
    pdf_export: true,
    api_access: false,
    slack_integration: false,
    custom_branding: false,
    priority_support: false,
    payroll_connectors: false,
  },
  standard: {
    email_notifications: true,
    push_notifications: false,
    csv_export: true,
    pdf_export: true,
    api_access: false,
    slack_integration: false,
    custom_branding: false,
    priority_support: false,
    payroll_connectors: false,
  },
  pro: {
    email_notifications: true,
    push_notifications: true,
    csv_export: true,
    pdf_export: true,
    api_access: true,
    slack_integration: true,
    custom_branding: true,
    priority_support: false,
    payroll_connectors: false,
  },
  expert: {
    email_notifications: true,
    push_notifications: true,
    csv_export: true,
    pdf_export: true,
    api_access: true,
    slack_integration: true,
    custom_branding: true,
    priority_support: true,
    payroll_connectors: true,
  },
};

export function hasFeature(planCode, featureKey) {
  return !!PLAN_FEATURES[planCode || "trial"]?.[featureKey];
}

export function nextTierWithFeature(featureKey) {
  for (const code of PLAN_ORDER) {
    if (PLAN_FEATURES[code]?.[featureKey]) return code;
  }
  return null;
}

export function formatCurrency(amount, currency = "EUR") {
  const opts = { style: "currency", currency, maximumFractionDigits: 0 };
  return new Intl.NumberFormat("fr-FR", opts).format(amount);
}

export function trialDaysLeft(trialEndsAt) {
  if (!trialEndsAt) return null;
  const end = new Date(trialEndsAt).getTime();
  const now = Date.now();
  return Math.max(0, Math.ceil((end - now) / (1000 * 60 * 60 * 24)));
}
